import { render } from "./UpsellConfirmed.vue?vue&type=template&id=2601539c"
import script from "./UpsellConfirmed.vue?vue&type=script&lang=js"
export * from "./UpsellConfirmed.vue?vue&type=script&lang=js"

import "./UpsellConfirmed.vue?vue&type=style&index=0&id=2601539c&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__